export default "__VITE_ASSET__DMT4VauM__"